import { render } from "./UiZahlungsverkehrReadOnly.pug?vue&type=template&id=29dfe9c5&lang=pug"
import script from "./UiZahlungsverkehrReadOnly.js?vue&type=script&lang=js"
export * from "./UiZahlungsverkehrReadOnly.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__